export const TESTIMONIALS = [
  { key: "t1", avatarTone: "teal", delay: 0 },
  { key: "t2", avatarTone: "gold", delay: 1 },
  { key: "t3", avatarTone: "teal", delay: 2 },
];